/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const changePrice = createAsyncThunk(
  'products/changePrice',
  async ({ productId, variantId = 'default', price }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const { data } = await sdk.products.changePrice(productId, variantId, price);
      return data;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not change product price';
      showErrorDialog(errorMessage);
      Logger.error(
        new Error('Error product change price'),
        { error },
        ['ChangePriceProductFailed', errorMessage || 'NoMessage'],
      );
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      changePrice.pending,
      (state, { meta }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = true;
          }
        });
      },
    )
    .addCase(
      changePrice.fulfilled,
      (state, { meta, payload }) => {
        const { productId } = meta.arg;
        state.items.forEach((product) => {
          if (product._id === productId) {
            product.isBusy = false;
            product.variants = payload.variants;
            product.defaultVariant = payload.defaultVariant;
          }
        });
      },
    )
    .addCase(
      changePrice.rejected,
      (state, { meta, error }) => {
        state.items.forEach((product) => {
          if (product._id === meta.arg.productId) {
            product.isBusy = false;
          }
        });
        state.error = error;
      },
    );
};
